import { apiPostAuth, apiPutAuth, apiGetAuth, apiGetPdfAuth, apiDeleteAuth, apiPostAuthWithCustomHeadersResponseType } from '@/utils/api'
import { API_COMPANY, API_EMPLOYEE, API_COMPANY_SUBDIVISION } from '@/utils/api-url'
import { invalidateCoreMappingCache } from '@/utils/core-mapping-cache'
import { checkRoleAccess, getUserProfile } from '@/utils/auth'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  adendum_list: { data: [] },
  addendum_additional: [],
  riplay_list: { data: [] },
  toggle_modal_riplay: false,
  data_modal_riplay: {},
  company_list: { 
    isLoading: false,
    data: {}
  },
  company_lpd_list: { 
    isLoading: false,
    data: {}
  },
  export_company_report_lpd: {
    isLoading: false,
    data: {}
  },
  detail_company: {},
  detail_company_existing: {
    isLoading: false,
    data: {}
  },
  is_editable: false,
  program_setting: {
    addendum_list: [],
    business_number_file: '',
    business_permit_file: '',
    business_establishment_deed_file: '',
    domicile_file: '',
    npwp_file: '',
    director_list: [],
    pic_list: [],
    shareholder_list: []
  },
  pml_setting: {},
  funding_source_setting: {},
  investment_type_setting: {},
  detail_modal_preview: {},
  meta_valid: false,
  data_modal_add_edit: {},
  data_modal_add_position: {},
  toggle_modal_addendum: false,
  toggle_modal_add_position: false,
  toggle_modal_add_edit_discard: {
    targetModals: false,
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loadingTable: false,
    loadingPopUp: false,
    modalSummary: false
  },
  meta_filter: {
    order_by: 'updated_at',
    sort_by: 'desc'
  }
}

const mutations = {
  "SET_ADENDUM_LIST": (state, payload) => {
    state.adendum_list = payload
  },
  "SET_ADENDUM_ADDITIONAL": (state, payload) => {
    state.addendum_additional = payload
  },
  "SET_RIPLAY_LIST": (state, payload) => {
    state.riplay_list = payload
  },
  "SET_TOGGLE_MODAL_RIPLAY": (state, payload) => {
    state.toggle_modal_riplay = payload
  },
  "SET_DATA_MODAL_RIPLAY": (state, payload) => {
    state.data_modal_riplay = payload
  },
  "SET_COMPANY_LIST": (state, payload) => {
    state.company_list = payload
  },
  "SET_COMPANY_LPD_LIST": (state, payload) => {
    state.company_lpd_list = payload
  },
  "SET_EXPORT_COMPANY_REPORT_LPD": (state, payload) => {
    state.export_company_report_lpd = payload
  },
  "SET_DETAIL_COMPANY": (state, payload) => {
    state.detail_company = payload
  },
  "SET_DETAIL_COMPANY_EXISTING": (state, payload) => {
    state.detail_company_existing = payload
  },
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_DATA_MODAL_ADD_POSITION": (state, payload) => {
    state.data_modal_add_position = payload
  },
  "SET_TOGGLE_MODAL_ADDENDUM": (state, payload) => {
    state.toggle_modal_addendum = payload
  },
  "SET_TOGGLE_MODAL_ADD_POSITION": (state, payload) => {
    state.toggle_modal_add_position = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  },
  "SET_IS_EDITABLE": (state, payload) => {
    state.is_editable = payload
  },
  "SET_PROGRAM_SETTING": (state, payload) => {
    state.program_setting = payload
  },
  "SET_PML_SETTING": (state, payload) => {
    state.pml_setting = payload
  },
  "SET_FUNDING_SOURCE_SETTING": (state, payload) => {
    state.funding_source_setting = payload
  },
  "SET_INVESTMENT_TYPE_SETTING": (state, payload) => {
    state.investment_type_setting = payload
  },
  "SET_DETAIL_MODAL_PREVIEW": (state, payload) => {
    state.detail_modal_preview = payload
  },
  "SET_META_VALID": (state, payload) => {
    state.meta_valid = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  }
}

const actions = {
  async getAdendumList(context, payload) {
    try {
      const response = await apiGetAuth(API_COMPANY.LIST_ADENDUM, payload)
      context.commit('SET_ADENDUM_LIST', response.data)
    } catch (err) {
      notificationDanger(err)
    }
  },
  async getRiplayList(context, payload) {
    try {
      const response = await apiGetAuth(API_COMPANY.LIST_RIPLAY, payload)
      context.commit('SET_RIPLAY_LIST', response.data)
    } catch (err) {
      notificationDanger(err)
    }
  },
  async createRiplay(context, payload) {
    try {
      const response = await apiPostAuth(API_COMPANY.LIST_RIPLAY, payload)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async updateRiplay(context, payload) {
    try {
      const response = await apiPutAuth(API_COMPANY.RIPLAY_BY_ID(payload.id), payload.reqBody)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async deleteRiplay(context, payload) {
    try {
      const response = await apiDeleteAuth(API_COMPANY.RIPLAY_BY_ID(payload))
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getExistingCompanyCore(context, payload) {
    context.commit('SET_DETAIL_COMPANY_EXISTING', { isLoading: true })
    try {
      const response = await apiGetAuth(API_COMPANY.COMPANY_EXISTING, payload)
      return response?.data
    } catch (err) {
      context.commit('SET_DETAIL_COMPANY_EXISTING', {
        isLoading: false,
        data: {}
      })
      throw err
    }
  },
  async getCompanyList(context, payload) {
    const roleName = getUserProfile()?.role?.name?.toUpperCase()
    const canViewCompany = roleName === 'SUPER ADMIN' || checkRoleAccess('view', 'Data Perusahaan')

    // Company lists support filters on many screens. Leave those filters empty
    // when the role cannot view company data instead of sending a forbidden GET.
    if (!canViewCompany) {
      context.commit('SET_COMPANY_LIST', { isLoading: false, data: {} })
      return
    }

    context.commit('SET_COMPANY_LIST', { isLoading: true })
    try {
      const response = await apiGetAuth(API_COMPANY.LIST, payload)
      context.commit('SET_COMPANY_LIST', {
        isLoading: false,
        data: response?.data
      })
    } catch (err) {
      context.commit('SET_COMPANY_LIST', {
        isLoading: false,
        data: {}
      })
      notificationDanger(err)
    }
  },
  async getCompanyLpdList(context, payload) {
    context.commit('SET_COMPANY_LPD_LIST', { isLoading: true })
    try {
      const response = await apiGetAuth(API_COMPANY.BY_ID_LPD(payload?.id), payload?.params)
      context.commit('SET_COMPANY_LPD_LIST', {
        isLoading: false,
        data: response?.data
      })
      return { isLoading: false, data: response?.data }
    } catch (err) {
      context.commit('SET_COMPANY_LPD_LIST', {
        isLoading: false,
        data: {}
      })
      notificationDanger(err)
      return { isLoading: false, data: {} }
    }
  },
  async getDetailCompany(context, payload) {
    try {
      const response = await apiGetAuth(API_COMPANY.BY_ID(payload))
      const companyData = response.data.data

      const [empResult, subResult] = await Promise.allSettled([
        apiGetAuth(API_EMPLOYEE.LIST, { company_id: payload, limit: 1, page: 1 }),
        apiGetAuth(API_COMPANY_SUBDIVISION.LIST, { company_id: payload, limit: 1, page: 1 })
      ])

      if (empResult.status === 'fulfilled') {
        const realTotal = empResult.value?.data?.other?.total
        if (realTotal !== undefined && realTotal !== null) companyData.total_employee = realTotal
      }
      if (subResult.status === 'fulfilled') {
        const realTotal = subResult.value?.data?.other?.total
        if (realTotal !== undefined && realTotal !== null) companyData.total_subdivision = realTotal
      }

      context.commit('SET_DETAIL_COMPANY', companyData)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async createCompany(context, payload) {
    try {
      const response = await apiPostAuth(API_COMPANY.CREATE_COMPANY, payload)
      invalidateCoreMappingCache()
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async updateCompany (context, payload) {
    try {
      const response = await apiPutAuth(API_COMPANY.BY_ID(payload.id), payload.reqBody)
      invalidateCoreMappingCache()
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      const errMsg = error?.response?.data?.message || ''
      if (errMsg.toLowerCase().includes('addendum')) {
        notificationDanger({ message: 'Perubahan data membutuhkan addendum. Silakan tambah dokumen adendum di tab Adendum sebelum menyimpan.' })
      } else {
        notificationDanger(error)
      }
    }
  },
  async regenerateECertificate (context, companyId) {
    try {
      const response = await apiPostAuth(API_COMPANY.REGENERATE_E_CERTIFICATE(companyId))
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async deleteCompany (context, payload) {
    try {
      const response = await apiDeleteAuth(API_COMPANY.BY_ID(payload))
      invalidateCoreMappingCache()
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async exportCompanyReportLpd(context, payload) {
    context.commit('SET_EXPORT_COMPANY_REPORT_LPD', { isLoading: true })
    try {
      const response = await apiGetPdfAuth(API_COMPANY.DOWNLOAD_LPD(payload))
      context.commit('SET_EXPORT_COMPANY_REPORT_LPD', {
        isLoading: false,
        data: response
      })
    } catch (error) {
      notificationDanger(error)
      context.commit('SET_EXPORT_COMPANY_REPORT_LPD', {
        isLoading: false,
        data: {}
      })
    }
  },
  async exportEmployeeData(context, payload) {
    try {
      const response = await apiPostAuthWithCustomHeadersResponseType(API_COMPANY.EXPORT_EMPLOYEE(payload))
      return response
    } catch (error) {
      notificationDanger(`Failed to export`)
    }
  },
  async createBulkEmployeePosition(context, payload) {
    try {
      const response = await apiPostAuth(API_COMPANY.CREATE_BULK_EMPLOYEE_POSITION(payload.id), payload.reqBody)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      throw error
    }
  }
}

const getters = {
  get_adendum_list: state => {
    return state.adendum_list
  },
  get_addendum_additional: state => {
    return state.addendum_additional
  },
  get_riplay_list: state => {
    return state.riplay_list
  },
  get_toggle_modal_riplay: state => {
    return state.toggle_modal_riplay
  },
  get_data_modal_riplay: state => {
    return state.data_modal_riplay
  },
  get_company_list: state => {
    return state.company_list
  },
  get_company_lpd_list: state => {
    return state.company_lpd_list
  },
  get_export_company_report_lpd: state => {
    return state.export_company_report_lpd
  },
  get_detail_company: state => {
    return state.detail_company
  },
  get_detail_company_existing: state => {
    return state.detail_company_existing
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  },
  get_data_modal_add_position: state => {
    return state.data_modal_add_position
  },
  get_toggle_modal_addendum: state => {
    return state.toggle_modal_addendum
  },
  get_toggle_modal_add_position: state => {
    return state.toggle_modal_add_position
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  },
  get_is_editable: state => {
    return state.is_editable
  },
  get_program_setting: state => {
    return state.program_setting
  },
  get_pml_setting: state => {
    return state.pml_setting
  },
  get_funding_source_setting: state => {
    return state.funding_source_setting
  },
  get_investment_type_setting: state => {
    return state.investment_type_setting
  },
  get_detail_modal_preview: state => {
    return state.detail_modal_preview
  },
  get_meta_valid: state => {
    return state.meta_valid
  },
  meta_filter: state => {
    return state.meta_filter
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
